import { Button, Col, Input, Modal, Row, Slider } from "antd";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Game } from "../../API";
import { setCloseGameAction } from "../../features/casinotheme";

type ModalBuyInProps = {
  balance?: number;
  game: Game;
  setBuyIn: (buyInAmount: number) => void;

  currency: string;
};

export const ModalBuyIn: React.FC<ModalBuyInProps> = ({
  balance = 0,
  game,
  currency,
  setBuyIn,
}) => {
  const [buyInAmount, setBuyInAmount] = useState<number>(
    parseFloat(balance.toFixed(2))
  );
  const [gameImage, setGameImage] = useState<string | null>(null);
  const [modalVisible, setModalVisible] = useState<boolean>(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  useEffect(() => {
    if (game) {
      const gamedata = JSON.parse(game.gamedata);
      setGameImage(gamedata.details.thumbnails["300x300"]);
    }
  }, []);

  return (
    <Modal
      visible={modalVisible}
      title={`Buy In - ${game.name}`}
      footer={
        balance === 0 ? (
          <Button
            onClick={() => {
              setModalVisible(false);
              navigate(-1);
            }}
          >
            <FormattedMessage id="Close" />
          </Button>
        ) : (
          <Button
            disabled={buyInAmount <= 0}
            block
            onClick={() => {
              if (setBuyIn) {
                setBuyIn(buyInAmount);
                setModalVisible(false);
              }
            }}
          >
            Buy In
          </Button>
        )
      }
      closable={true}
      onCancel={() => {
        dispatch(setCloseGameAction(true));
      }}
    >
      <div className="modal-buyin-container">
        <Row gutter={20}>
          {gameImage && (
            <Col>
              <img src={gameImage} style={{ width: "150px" }} alt="" />
            </Col>
          )}
          {balance > 0 && (
            <Col>
              <h4>
                <FormattedMessage id="How much do you want to play?" />
              </h4>
              <Input
                addonBefore={currency}
                value={buyInAmount}
                onChange={(evt) => {
                  setBuyInAmount(
                    isNaN(parseFloat(evt.target.value))
                      ? 0
                      : parseFloat(evt.target.value) > balance
                      ? balance
                      : parseFloat(evt.target.value)
                  );
                }}
              />
              <Slider
                onChange={(v: number) => {
                  setBuyInAmount(parseFloat(((balance * v) / 100).toFixed(2)));
                }}
                step={1}
                value={(buyInAmount / balance) * 100}
              />
              <div className="buyin-button">
                <Button
                  disabled={5 > balance}
                  onClick={() => {
                    setBuyInAmount(5 > balance ? balance : 5);
                  }}
                >
                  5
                </Button>
                <Button
                  disabled={10 > balance}
                  onClick={() => {
                    setBuyInAmount(10 > balance ? balance : 10);
                  }}
                >
                  10
                </Button>
                <Button
                  disabled={15 > balance}
                  onClick={() => {
                    setBuyInAmount(15 > balance ? balance : 15);
                  }}
                >
                  15
                </Button>
                <Button
                  disabled={20 > balance}
                  onClick={() => {
                    setBuyInAmount(20 > balance ? balance : 20);
                  }}
                >
                  20
                </Button>
                <Button
                  onClick={() => {
                    setBuyInAmount(balance);
                  }}
                >
                  Max
                </Button>
              </div>
            </Col>
          )}
          {balance <= 0 && (
            <Col>
              <p>
                <FormattedMessage id="You don't have enough funds !!!" />
              </p>
            </Col>
          )}
        </Row>
      </div>
    </Modal>
  );
};
